var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentStatusPaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1BC47D",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13976_64623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13976_64623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8311 14.6017L7.42969 11.0269V9.93131H9.26931C9.67915 9.93131 10.0345 9.80402 10.3354 9.54944C10.6364 9.29477 10.8211 8.97585 10.8897 8.59269H6.92969V7.45519H10.7577C10.624 7.18152 10.4216 6.9599 10.1503 6.79031C9.87915 6.62073 9.57852 6.53594 9.24844 6.53594H6.92969V5.39844H13.0672V6.53594H11.4751C11.5798 6.65969 11.677 6.8009 11.7667 6.95956C11.8564 7.11823 11.9252 7.28344 11.9732 7.45519H13.0672V8.59269H12.0487C11.976 9.2931 11.6834 9.8779 11.1707 10.3471C10.658 10.8163 10.0452 11.0549 9.33219 11.0628H9.03844L12.4098 14.6017H10.8311Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusPaid);
export default __webpack_public_path__ + "static/media/payment_status_paid.4e6feacc3f371fe06ca933dccec72d53.svg";
export { ForwardRef as ReactComponent };